export const classes = {
  wrapper: 'relative size-full overflow-hidden flex flex-col',
  controls: 'grow-0 shrink-0',
  documentWrapper:
    'relative w-full min-h-0 grow overflow-auto bg-white dark:bg-none dark:bg-white/[0.05] bg-gradient-to-br to-white from-blue-200/20 from-50%',
  page: 'js-page shrink-0 mt-10 shadow-dialog rounded-md border border-grey-2 dark:border-white/10 overflow-hidden',
  document:
    'px-4 py-12 flex flex-col grow items-center min-h-0 overflow-auto size-full',
  message: 'p-12 text-lg text-center text-grey-7 dark:text-mauve-2',
};

export function getPageMarkerClass(pageNumber: number) {
  return `js-page_${pageNumber}`;
}

export function getPageScrollTop(documentEl: HTMLElement, pageNumber: number) {
  const pageEl = documentEl.querySelector(`.js-page_${pageNumber}`);
  const firstPageEl = documentEl.querySelector('.js-page_1');
  if (!pageEl || !firstPageEl) return undefined;
  return (
    pageEl.getBoundingClientRect().top - firstPageEl.getBoundingClientRect().top
  );
}
